<template>
    <div class="be-error">
        {{ showError() }}
    </div>
</template>

<script>
  export default {
    name: "ErrorField",
    props: {
      errors: {
        type: Array,
        default: null
      },
      field: {
        type: String,
        default: null
      }
    },
    methods: {
      showError() {
        if (this.errors.length) {

          var filterResult = this.errors.filter(
            error => error.field === this.field
          );
          if (filterResult[0]) return filterResult[0].message;
        }
        return "";
      }
    }
  };
</script>
<style scoped>
    .be-error {
        color: red;
        margin-bottom: 20px;
    }
</style>
